<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:profile="formData.pic = $event"
      
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import CompanyForm from "../../../components/settings/company/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": CompanyForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupcompany.newcompany'),
      pageTitleValue: "",
      formData: {
        compnycode: null,
        compnyname: null,
        regno: null,
        //startdate: null,
        //enddate: null,
        addr1: null,
        addr2: null,
        addr3: null,
        cityid: null,
        cntryid: null,
        postcode: null,
        tel: null,
        www: null,
        email: null,
        crcyid: null,
        parentcompnyid: null,
        picture: null,
        isdisable: false,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      countryList: [],
      cityList: [],
      parentCompanyList: [],
      currencyList: [],
      countries: [],
      cities: [],
      currencies: [],
      parentCompanies: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      // Convert boolean to integer. 1 = true, 0 = false
      if (this.formData.isdisable == false) {
        this.formData.isdisable = 0;
      } else {
        this.formData.isdisable = 1;
      }

      this.$store.dispatch('post', {url: "/company/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "companylist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "companylist" });
    },
  },
};
</script>